
import { Options, Vue } from "vue-class-component";
import PageLayout from "@/components/layouts/index.vue";

@Options({
  name: "app",
  components: {
    PageLayout,
  },
})
export default class App extends Vue {}
